// function initAutoPagination() {
//     const wrapper = document.querySelector(".template-index #main");
//     const sections = wrapper ? wrapper.querySelectorAll("section") : [];

//     const pagination = document.getElementById("auto-pagination");
//     if (!pagination) return;

//     const dotMap = new Map();

//     // Tạo dots
//     sections.forEach((sec, index) => {
//         let secId = sec.getAttribute("id") || `section${index + 1}`;
//         if (!sec.id) sec.id = secId;

//         const dot = document.createElement("span");
//         dot.className = "dot" + (index === 0 ? " active" : "");
//         dot.dataset.target = secId;

//         const name = document.createElement("span");
//         name.className = "dot-section-name";
//         name.innerText = sec.dataset.name || secId;
//         dot.appendChild(name);

//         pagination.appendChild(dot);
//         dotMap.set(secId, dot);

//         // CLICK DOT
//         dot.addEventListener("click", function (e) {
//             e.preventDefault();

//             const current = pagination.querySelector(".dot.active");
//             if (current) current.classList.remove("active");
//             dot.classList.add("active");

//             const targetSection = document.getElementById(secId);
//             if (targetSection) {
//                 targetSection.scrollIntoView({
//                     behavior: "smooth",
//                     block: "start"
//                 });
//             }
//         });
//     });

//     // Set active theo id
//     function setActiveById(id) {
//         if (!id) return;
//         dotMap.forEach((d, key) => {
//             if (key === id) d.classList.add("active");
//             else d.classList.remove("active");
//         });
//     }

//     // IntersectionObserver
//     if ('IntersectionObserver' in window) {
//         const visibleMap = new Map();

//         const io = new IntersectionObserver((entries) => {
//             entries.forEach(entry => {
//                 visibleMap.set(entry.target.id, entry.intersectionRatio);
//             });

//             let bestId = null;
//             let bestRatio = 0;
//             visibleMap.forEach((ratio, id) => {
//                 if (ratio > bestRatio) {
//                     bestRatio = ratio;
//                     bestId = id;
//                 }
//             });

//             if (bestId) setActiveById(bestId);
//         }, {
//             root: null,
//             rootMargin: '0px',
//             threshold: [0, 0.25, 0.5, 0.75, 1]
//         });

//         sections.forEach(s => io.observe(s));

//     } else {
//         // Fallback scroll
//         let ticking = false;

//         function onScroll() {
//             if (!ticking) {
//                 window.requestAnimationFrame(() => {
//                     let bestId = null;
//                     let bestDistance = Infinity;
//                     const center = window.innerHeight / 2;

//                     sections.forEach(s => {
//                         const rect = s.getBoundingClientRect();
//                         const distance = Math.abs((rect.top + rect.height / 2) - center);

//                         if (distance < bestDistance) {
//                             bestDistance = distance;
//                             bestId = s.id;
//                         }
//                     });

//                     if (bestId) setActiveById(bestId);
//                     ticking = false;
//                 });
//                 ticking = true;
//             }
//         }

//         window.addEventListener('scroll', onScroll, { passive: true });
//         onScroll();
//     }

//     // Resize fallback
//     window.addEventListener('resize', function () {
//         if (!('IntersectionObserver' in window)) {
//             window.dispatchEvent(new Event('scroll'));
//         }
//     }, { passive: true });
// }

function initAutoPagination(options = {}) {
  const {
    pageSelector = 'body',                 // scope page (vd: .template-index)
    wrapperSelector = '#main',              // wrapper chứa sections
    sectionSelector = 'section',            // selector section
    paginationSelector = '#auto-pagination',// pagination container
    activeClass = 'active',
    threshold = [0, 0.25, 0.5, 0.75, 1]
  } = options;

  const page = document.querySelector(pageSelector);
  if (!page) return;

  const wrapper = page.querySelector(wrapperSelector);
  if (!wrapper) return;

  const sections = wrapper.querySelectorAll(sectionSelector);
  if (!sections.length) return;

  const pagination = document.querySelector(paginationSelector);
  if (!pagination) return;

  pagination.innerHTML = ''; // reset khi dùng cho page khác

  const dotMap = new Map();

  /* =====================
     CREATE DOTS
  ===================== */
  sections.forEach((sec, index) => {
    let secId = sec.id || `section-${index + 1}`;
    sec.id = secId;

    const dot = document.createElement('span');
    dot.className = 'dot' + (index === 0 ? ` ${activeClass}` : '');
    dot.dataset.target = secId;

    const name = document.createElement('span');
    name.className = 'dot-section-name';
    name.textContent = sec.dataset.name || secId;

    dot.appendChild(name);
    pagination.appendChild(dot);
    dotMap.set(secId, dot);

    // CLICK DOT
    dot.addEventListener('click', e => {
      e.preventDefault();
      setActiveById(secId);

      sec.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  });

  /* =====================
     SET ACTIVE
  ===================== */
  function setActiveById(id) {
    dotMap.forEach((dot, key) => {
      dot.classList.toggle(activeClass, key === id);
    });
  }

  /* =====================
     INTERSECTION OBSERVER
  ===================== */
  if ('IntersectionObserver' in window) {
    const visibleMap = new Map();

    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        visibleMap.set(entry.target.id, entry.intersectionRatio);
      });

      let bestId = null;
      let bestRatio = 0;

      visibleMap.forEach((ratio, id) => {
        if (ratio > bestRatio) {
          bestRatio = ratio;
          bestId = id;
        }
      });

      if (bestId) setActiveById(bestId);
    }, {
      root: null,
      rootMargin: '0px',
      threshold
    });

    sections.forEach(sec => io.observe(sec));

  } else {
    /* =====================
       SCROLL FALLBACK
    ===================== */
    let ticking = false;

    function onScroll() {
      if (ticking) return;

      ticking = true;
      requestAnimationFrame(() => {
        let bestId = null;
        let bestDistance = Infinity;
        const center = window.innerHeight / 2;

        sections.forEach(sec => {
          const rect = sec.getBoundingClientRect();
          const distance = Math.abs(
            (rect.top + rect.height / 2) - center
          );

          if (distance < bestDistance) {
            bestDistance = distance;
            bestId = sec.id;
          }
        });

        if (bestId) setActiveById(bestId);
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    window.addEventListener('resize', () => {
      window.dispatchEvent(new Event('scroll'));
    }, { passive: true });
  }
}
// *****
function initVerticalSliders() {
    // tốc độ từng slider
    const speeds = {
        t1: 6,
        t2: 4.5,
        t3: 3,
        t4: 4,
        t5: 5
    };

    const tracks = document.querySelectorAll(".vertical-slider-track");

    tracks.forEach(track => {
        // nhân đôi ảnh để loop mượt
        track.innerHTML += track.innerHTML;

        let pos = 0;
        const speed = speeds[track.classList[1]] || 1;

        function run() {
            pos -= speed;
            track.style.transform = `translateY(${pos}px)`;

            if (Math.abs(pos) >= track.scrollHeight / 2) {
                pos = 0;
            }

            requestAnimationFrame(run);
        }

        run();
    });
}
// ADD SENSE CHO BANNER TEXT 
function wrapSectionsWithSense({
    sectionASelector,
    sectionBSelector,
    wrapperClass = "shopify-section sense"
    } = {}) {
    const sectionA = document.querySelector(sectionASelector);
    const sectionB = document.querySelector(sectionBSelector);

    if (!sectionA || !sectionB) return;

    // Tránh bọc lại nhiều lần
    if (sectionA.closest(".sense")) return;

    const sense = document.createElement("section");
    sense.className = wrapperClass;

    // Chèn sense vào vị trí của section A
    sectionA.parentNode.insertBefore(sense, sectionA);

    // Di chuyển A & B vào sense
    sense.appendChild(sectionA);
    sense.appendChild(sectionB);
}

// Scroll section hiển thị từ trái sang phải 

function initImageOverlayScroll() {
  const scene = document.querySelector(
    "section.shopify-section.sense"
  );

  const sectionB = document.querySelector(
    "section.shopify-section--image-with-text-overlay-scroll"
  );

  if (!scene || !sectionB) return;

  function imageOverlayScroll() {
    const scrollY = window.scrollY;
    const sceneTop = scene.offsetTop;
    const sceneHeight = scene.offsetHeight;
    const vh = window.innerHeight;

    const start = sceneTop;
    const end = sceneTop + vh;
    const releasePoint = sceneTop + sceneHeight - vh;

    // Progress 0 → 1
    let progress = (scrollY - start) / (end - start);
    progress = Math.max(0, Math.min(1, progress));

    // ===== TRONG SCENE =====
    if (scrollY >= start && scrollY <= releasePoint) {
      sectionB.style.position = "fixed";
      sectionB.style.top = "0";
      sectionB.style.left = "0";

      // TRÁI → PHẢI
      const translateX = 100 - progress * 100;
      sectionB.style.transform = `translateX(${translateX}%)`;
    }

    // ===== QUA SCENE =====
    else if (scrollY > releasePoint) {
      sectionB.style.position = "absolute";
      sectionB.style.top = "100vh";
      sectionB.style.transform = "translateX(0)";
    }

    // ===== TRƯỚC SCENE =====
    else {
      sectionB.style.position = "fixed";
      sectionB.style.top = "0";
      sectionB.style.transform = "translateX(-100%)";
    }
  }

  // Gắn event
  window.addEventListener("scroll", imageOverlayScroll);
  window.addEventListener("resize", imageOverlayScroll);

  // Chạy lần đầu để set trạng thái đúng
  imageOverlayScroll();
}


///parallax product-tabs



// *********************//

// Hàm chính gắn scroll cho ảnh
// function handleImageScroll(imageId, targetSectionId) {
//   const image = document.getElementById(imageId);
//   const targetSection = document.getElementById(targetSectionId);

//   function onScroll() {
//     const sectionTop = targetSection.getBoundingClientRect().top;
//     const triggerPoint = window.innerHeight * 0.85;

//     if (sectionTop <= triggerPoint) {
//       image.classList.add("move-down");
//     } else {
//       image.classList.remove("move-down");
//     }
//   }

//   // Gắn event listener
//   window.addEventListener("scroll", onScroll);
// }

// clip-path animation
// function initClipScroll(options = {}) {
//   const {
//     sectionSelector,
//     maskSelector,
//     speed = 0.0015,
//     startX = 20,
//     startY = 35,
//     endX = 100,
//     endY = 100,
//     activeTop = 0.4,
//     activeBottom = 0.6
//   } = options;

//   const section = document.querySelector(sectionSelector);
//   const mask = document.querySelector(maskSelector);

//   if (!section || !mask) return;

//   let progress = 0; // 0 → 1

//   function updateClip() {
//     const x = startX + progress * (endX - startX);
//     const y = startY + progress * (endY - startY);
//     mask.style.clipPath = `ellipse(${x}% ${y}% at center)`;
//   }

//   function onWheel(e) {
//     const rect = section.getBoundingClientRect();
//     const inView =
//       rect.top <= window.innerHeight * activeTop &&
//       rect.bottom >= window.innerHeight * activeBottom;

//     if (!inView) return;

//     const scrollingDown = e.deltaY > 0;
//     const scrollingUp = e.deltaY < 0;

//     // mở clip
//     if (scrollingDown && progress < 1) {
//       e.preventDefault();
//       progress += e.deltaY * speed;
//       progress = Math.min(1, progress);
//       updateClip();
//       return;
//     }

//     // đóng clip
//     if (scrollingUp && progress > 0) {
//       e.preventDefault();
//       progress += e.deltaY * speed;
//       progress = Math.max(0, progress);
//       updateClip();
//       return;
//     }
//     // clip xong → thả scroll
//   }

//   window.addEventListener('wheel', onWheel, { passive: false });
//   updateClip();
// }

function initClipScroll(config = {}) {
  const {
    section,            // element | selector
    mask,               // element | selector

    // clip-path config
    type = 'ellipse',   // 'ellipse' | 'inset'
    start = { x: 20, y: 35 },
    end   = { x: 100, y: 100 },
    center = 'center',  // 'center' | '50% 40%' | 'left top'

    speed = 0.0015,

    // active zone
    activeTop = 0.4,
    activeBottom = 0.6
  } = config;

  const sectionEl =
    typeof section === 'string' ? document.querySelector(section) : section;

  const maskEl =
    typeof mask === 'string' ? sectionEl?.querySelector(mask) : mask;

  if (!sectionEl || !maskEl) return;

  let progress = 0;

  function buildClipPath(p) {
    const x = start.x + p * (end.x - start.x);
    const y = start.y + p * (end.y - start.y);

    if (type === 'ellipse') {
      return `ellipse(${x}% ${y}% at ${center})`;
    }

    if (type === 'inset') {
      return `inset(${x}% ${y}% ${x}% ${y}%)`;
    }

    return '';
  }

  function update() {
    maskEl.style.clipPath = buildClipPath(progress);
  }

  function onWheel(e) {
    const rect = sectionEl.getBoundingClientRect();
    const inView =
      rect.top <= window.innerHeight * activeTop &&
      rect.bottom >= window.innerHeight * activeBottom;

    if (!inView) return;

    const delta = e.deltaY * speed;

    // DOWN
    if (e.deltaY > 0 && progress < 1) {
      e.preventDefault();
      progress = Math.min(1, progress + delta);
      update();
    }

    // UP
    if (e.deltaY < 0 && progress > 0) {
      e.preventDefault();
      progress = Math.max(0, progress + delta);
      update();
    }
  }

  window.addEventListener('wheel', onWheel, { passive: false });
  update();
}


// *****

function handleImageScroll(imageClass, targetSectionId) {
  const targetSection = document.getElementById(targetSectionId);

  function onScroll() {
    // Lấy đúng ảnh cần di chuyển
    const image = document.querySelector(`.${imageClass}`);
    if (!image || !targetSection) return;

    const sectionTop = targetSection.getBoundingClientRect().top;
    const triggerPoint = window.innerHeight * 0.85;

    if (sectionTop <= triggerPoint) {
      image.classList.add("move-down");
    } else {
      image.classList.remove("move-down");
    }
  }

  window.addEventListener("scroll", onScroll);
}



document.addEventListener("DOMContentLoaded", function() {
    initAutoPagination({
        pageSelector: '.template-index',
        wrapperSelector: '#main',
        sectionSelector: 'section',
        paginationSelector: '#auto-pagination'
    });
    initAutoPagination({
        pageSelector: '.template-page-about-us',
        wrapperSelector: '#main',
        sectionSelector: 'section',
        paginationSelector: '#auto-pagination'
    });


    initVerticalSliders();
    wrapSectionsWithSense({
        sectionASelector: ".shopify-section--image-with-text-overlay",
        sectionBSelector: ".shopify-section--image-with-text-overlay-scroll"
    });
    initImageOverlayScroll();
    // initClipScroll({
    //     section: '#shopify-section-template--19920045900019__video_AkWiiY',
    //     mask: '.content-over-media',

    //     type: 'ellipse',
    //     start: { x: 20, y: 35 },
    //     end:   { x: 120, y: 120 },
    //     center: 'center',

    //     speed: 0.0012
    // });


    
    handleImageScroll("section-image-scroll", "tabs-products-template--19920045834483__product_tab_slider_wngCiC");
});
